import { css } from '@emotion/react';
import { FC } from 'react';

import { InfiniteScroll } from '@/components/InfiniteScroll';
import { ArticleThumbnail } from '@/components/News/ArticleThumbnail';
import { useInfiniteScroll } from '@/hooks/useInfiniteScroll';
import { NewsArticle } from '@/resources/NewsArticle';
import { BREAKPOINTS } from '@/styles/themes/default';

const wrapperStyles = css`
  margin: 48px 0;
  display: flex;
  flex-wrap: wrap;

  @media (min-width: ${BREAKPOINTS.Tablet.min}px) {
    margin: 64px 0 0 0;
  }

  @media (min-width: ${BREAKPOINTS.Desktop.min}px) {
    margin: 120px 0 0 0;
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    grid-column-gap: 16px;
    grid-row-gap: 64px;
  }
`;

const articleStyles = css`
  margin-bottom: 48px;

  @media (min-width: ${BREAKPOINTS.Desktop.min}px) {
    margin-bottom: 0;
  }
`;

interface IArticleListProps {
  articles: Array<NewsArticle>;
  initialNextArticlesLink?: string;
}

export const ArticlesList: FC<IArticleListProps> = ({ articles, initialNextArticlesLink }) => {
  const { isItemsLoading, loadedItemsState, hasMore, onLoadMore } = useInfiniteScroll(
    articles,
    initialNextArticlesLink
  );

  return (
    <InfiniteScroll
      hasMore={hasMore}
      loading={isItemsLoading}
      items={loadedItemsState}
      onLoadMore={onLoadMore}
      css={wrapperStyles}
    >
      {(item) => <ArticleThumbnail key={item.id} article={item} css={articleStyles} />}
    </InfiniteScroll>
  );
};
